
import { mapState } from 'vuex';
import BrandNotice from './components/BrandNotice';
import marked from 'marked';
import MileageNoticeHelper from '@/mixins/MileageNoticeHelper';

export default {
  name: 'BrandNoticesDialog',
  components: { BrandNotice },
  mixins: [MileageNoticeHelper],
  data() {
    return {
      isLoadingBrandNotices: true,
      brandNotices: [],
      selectedBrandNoticeId: null
    };
  },
  computed: {
    ...mapState('window', ['windowService']),
    ...mapState(['api']),
    selectedBrandNotice() {
      return (
        this.brandNotices.find(
          notice => notice.id === this.selectedBrandNoticeId
        ) || {}
      );
    },
    isMobile() {
      return this.$route.query.mobile === 'true';
    },
    showMileageNotices() {
      return this.$route.query.show_mileage_notices === 'true';
    }
  },
  created() {
    this.loadBrandNotices();
  },
  methods: {
    async loadBrandNotices() {
      this.isLoadingBrandNotices = true;
      try {
        const [{ data }, mileageNotice] = await Promise.all([
          this.api.fetchBrandNotices(),
          this.showMileageNotices
            ? this.fetchMileageNotice()
            : Promise.resolve(null)
        ]);

        this.brandNotices = [
          ...(mileageNotice
            ? [{ id: Symbol(), ...mileageNotice, format: 'raw' }]
            : []),
          ...data.brand_notices
        ];
      } finally {
        this.isLoadingBrandNotices = false;
      }
    },
    close() {
      this.windowService.closeFullscreenPopup();
    },
    setBrandNoticeId(id) {
      this.selectedBrandNoticeId = id;
    },
    unSetBrandNoticeId() {
      this.selectedBrandNoticeId = null;
    },
    firstParagraphMessage(message) {
      if (!message) return;

      const markedMessage = marked.parse(message, { breaks: true });
      const parser = new DOMParser();
      const doc = parser.parseFromString(markedMessage, 'text/html');

      const firstParagraph = doc.querySelector('p');

      return firstParagraph ? firstParagraph.textContent.trim() : '';
    }
  }
};
